import { FC } from 'react';

import { Backdrop, css, LinearProgress, styled } from '@mui/material';

export const Loader: FC = () => (
  <>
    <LinearProgress />
    <StyledBackdrop open />
  </>
);

const StyledBackdrop = styled(Backdrop)(
  () => css`
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 2;
  `
);

